import { KredietInfo } from "../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../components/BaseTable";
import { bedragFormat } from "../../../../shared/utils/currency";
import { formatDate, formatDuration } from "../../../formatters";

export const getKredietenColumns = (
  isHuidig?: boolean
): Column<KredietInfo>[] => {
  return [
    {
      header: "Krediet",
      accessor: () => "",
      align: "right",
    },
    {
      header: "Lopende of nieuwe polis",
      accessor: isHuidig ? () => "Bestaande polis" : "polis",
      align: "right",
    },
    {
      header: "Geldverstrekker",
      accessor: "geldverstrekker",
      align: "right",
    },
    {
      header: "Geldnemers",
      accessor: "geldnemers",
      align: "right",
    },
    {
      header: "Kredietvorm",
      accessor: "kredietvorm",
      align: "right",
    },
    {
      header: "Ingangsdatum krediet",
      accessor: "ingangsdatum",
      align: "right",
      dataType: "date",
    },
    {
      header: "Einddatum krediet, looptijd",
      accessor: (row) => {
        if (!row.einddatum) return null;
        const formattedDate = formatDate(row.einddatum);
        const durationString = formatDuration(row.looptijdInMaanden);
        return `${formattedDate}${durationString ? ", " + durationString : ""}`;
      },
      align: "right",
    },
    {
      header: "Kredietlimiet",
      accessor: "limiet",
      align: "right",
      dataType: "currency",
    },
    {
      header: "Krediethoofdsom",
      accessor: "hoofdsom",
      align: "right",
      dataType: "currency",
    },
    {
      header: "Gedeelte in box 1, einddatum renteaftrek",
      accessor: (row) => {
        if (!row.box1) return null;
        return `${bedragFormat(row.box1)} (${formatDate(
          row.einddatumRenteaftrek
        )})`;
      },
      align: "right",
    },
    {
      header: "Gedeelte in box 3",
      accessor: "box3",
      align: "right",
      dataType: "currency",
    },
    {
      header: "Jaarlijks kostenpercentage",
      accessor: "jaarlijksKostenPercentage",
      align: "right",
      dataType: "percentage",
    },
    {
      header: "Maandlast",
      accessor: "maandlast",
      align: "right",
      dataType: "currency-with-decimals",
    },
    {
      header: "Bestedingsdoel",
      accessor: "bestedingsdoel",
      align: "right",
    },
  ];
};
